import { NgModule } from '@angular/core';
import { DxAutocompleteModule } from 'devextreme-angular/ui/autocomplete';
import { DxPopupModule } from 'devextreme-angular/ui/popup';
import { DxDropDownBoxModule } from 'devextreme-angular/ui/drop-down-box';
import {
  FavouritesComponent,
  ScreenersDropdownComponent,
  GroupDropdownComponent
} from './components';
import {TuiInputFileModule,  TuiDataListWrapperModule, TuiRadioModule, TuiSelectModule} from '@taiga-ui/kit';
import { CommonService } from '../core/services/common.service';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartsModule } from '../charts/charts.module';
import { CalculatorsModule } from '../calculators/calculators.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import {CreditModule} from '../credit/credit.module';
import { AdvancedSearchModule } from 'app/advanced-search/advanced-search.module';
import { PresetsComponent } from './components/presets/presets.component';
import {TuiButtonModule, TuiDataListModule, TuiDialogModule, TuiLoaderModule, TuiHintModule, TuiSvgModule} from '@taiga-ui/core';
import { DxScrollViewModule } from 'devextreme-angular';

@NgModule({
  declarations: [
    FavouritesComponent,
    GroupDropdownComponent,
    ScreenersDropdownComponent,
    PresetsComponent
  ],
  imports: [
    CommonModule,
    DxAutocompleteModule,
    DxPopupModule,
    DxDropDownBoxModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    CalculatorsModule,
    NgxSpinnerModule,
    CreditModule,
    AdvancedSearchModule,
    TuiRadioModule,
    TuiLoaderModule,
    TuiInputFileModule,
    TuiDialogModule,
    TuiButtonModule,
    TuiSvgModule,
    TuiHintModule,
    TuiDialogModule,
    TuiSelectModule,
    TuiButtonModule,
    TuiDataListModule,
    TuiDataListWrapperModule,
    DxScrollViewModule
  ],
  exports: [
    FavouritesComponent
  ],
  entryComponents: [FavouritesComponent],
  providers: [
    CommonService
  ]
})
export class FavouritesModule {
}
